import { ChangeDetectionStrategy, Component, EventEmitter, inject, input, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';

import { UploadStatus } from '../file-upload/file-upload.types';

import { IDocument } from '~/repositories/dossiers/store/dossiers.models';
import { FileService } from '~/shared/services';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrl: './document.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DocumentComponent {
  private readonly fileService = inject(FileService);
  private readonly messageService = inject(MessageService);

  @Input() document: IDocument;
  @Input() editable: boolean;
  @Input() uploadProgress: number;
  @Input() uploadStatus: UploadStatus;
  @Input() isLink: boolean = false;
  canDelete = input<boolean>(false);

  @Output() removeDocument = new EventEmitter();
  @Output() cancelUpload = new EventEmitter();
  @Output() retryUpload = new EventEmitter();

  uploadStatusses = UploadStatus;

  constructor(private translateService: TranslateService) {}

  handleRemoveDocument(evt: MouseEvent) {
    evt.stopPropagation();

    this.removeDocument.emit();
  }

  downloadDocument = async () => {
    try {
      await this.fileService.downloadFile(
        `${environment.BACKEND_URL}${this.document.downloadPath}`,
        this.document.name
      );
    } catch (err) {
      console.error(err);
      this.messageService.add({
        severity: 'error',
        detail: this.translateService.instant('error.document.download'),
        life: 5000
      });
    }
  };

  handleDownload = (evt: MouseEvent) => {
    evt.stopPropagation();

    this.downloadDocument();
  };

  handleDocumentClick = (evt: MouseEvent) => {
    evt.preventDefault();
    evt.stopPropagation();

    if (this.document.inlineView) {
      this.fileService.openFileInViewer(`${environment.BACKEND_URL}${this.document.downloadPath}`, this.document.name, {
        canDownload: this.document.canDownload
      });
    } else if (this.document.canDownload) {
      this.downloadDocument();
    } else {
      this.messageService.add({
        severity: 'error',
        detail: this.translateService.instant('error.no.pdf.available.for.document'),
        life: 5000
      });
    }
  };
}
